/* bm-ficha.js — v116 (Wil, 8-oct-2026). Solo se carga en la ficha de producto (sections/main-product.liquid).
   · 018 B: precio corto del celular, línea del cupón y barra fija siguen a la variante elegida;
            la línea del cupón baja a la casilla del cupón (donde está «Aplicar»);
            WhatsApp flotante en el celular: botón redondo sobre la foto y, al bajar, encima de la barra.
   · 030: 3 reseñas reales de Judge.me bajo el botón de compra + «Ver más» y estrellas que bajan a las reseñas.
   Nada de esto toca el carrito, la nota del pedido ni el guardián de iniciales. */
(function () {
  'use strict';

  var root = document.querySelector('.bm-ficha-b');
  if (!root) return;
  var esCel = function () { return window.innerWidth < 750; };

  /* ---------- utilidades ---------- */
  function money(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function bajarA(el, extra) {
    if (!el) return;
    var header = document.querySelector('.section-header.shopify-section-header-sticky, sticky-header');
    var off = 80 + (extra || 0);
    if (header) { var hr = header.getBoundingClientRect(); if (hr.bottom > 0 && hr.bottom < 160) off = hr.bottom + 16 + (extra || 0); }
    /* el margen se calcula una vez, con el encabezado como está al tocar (al bajar se esconde y daría otro) */
    var destino = function () { return el.getBoundingClientRect().top + window.pageYOffset - off; };
    var ir = function (y) { try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); } };
    ir(destino());
    /* v118 ronda 3 (13-oct): si mientras baja la página sigue creciendo por encima del destino (Addi, «Lo que dicen quienes
       ya lo tienen», fotos que terminan de llegar), el destino se corre y el cliente quedaba 100–200 px más abajo. Se vuelve
       a apuntar a los 0,8 / 1,6 / 3 s, salvo que el cliente ya haya tocado o movido la página. */
    var suyo = false;
    var corta = function () { suyo = true; };
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (t) { window.addEventListener(t, corta, { once: true, passive: true }); });
    [800, 1600, 3000].forEach(function (ms) {
      setTimeout(function () { if (suyo) return; var y = destino(); if (Math.abs(y - window.pageYOffset) > 40) ir(y); }, ms);
    });
  }

  /* ---------- 018 B: precio, cupón y barra con la variante elegida ---------- */
  var mapa = null;
  try {
    var tag = root.querySelector('script[data-bmf-variantes]');
    if (tag) mapa = JSON.parse(tag.textContent);
  } catch (e) { mapa = null; }
  var precioBox = root.querySelector('[data-bmf-precio]');
  var cupon = root.querySelector('[data-bmf-cupon]');
  function idElegido() {
    var btn = root.querySelector('.product-form__submit');
    var f = (btn && btn.closest('form')) || root.querySelector('form[action*="/cart/add"]');
    var inp = f && f.querySelector('[name="id"]');
    return inp ? String(inp.value) : '';
  }
  var ultimo = '';
  function pintarPrecio() {
    if (!mapa) return;
    var id = idElegido();
    if (!id || id === ultimo || !mapa[id]) return;
    ultimo = id;
    var v = mapa[id];
    if (precioBox) {
      var now = precioBox.querySelector('[data-bmf-now]');
      var was = precioBox.querySelector('[data-bmf-was]');
      var off = precioBox.querySelector('[data-bmf-off]');
      var ago = precioBox.querySelector('[data-bmf-agotado]');
      if (now) now.textContent = money(v.p);
      var hay = v.c > v.p;
      if (was) { was.hidden = !hay; if (hay) was.textContent = money(v.c); }
      if (off) { off.hidden = !hay; if (hay) off.textContent = '-' + Math.round((v.c - v.p) * 100 / v.c) + '%'; }
      if (ago) { ago.hidden = !!v.a; ago.textContent = v.a ? '' : 'Agotado'; } /* v123 (137): sin texto «Agotado» en el HTML cuando hay stock */
    }
    if (cupon) {
      var b = cupon.querySelector('[data-bmf-cup-precio]');
      var monto = parseInt(cupon.getAttribute('data-monto'), 10) || 0;
      if (b) b.textContent = money(Math.max(0, v.p - monto));
      cupon.hidden = !v.a;
    }
    var sp = document.querySelector('[data-bmsa-precio]');
    if (sp) sp.textContent = money(v.p);
    var sa = document.querySelector('[data-bmsa-antes]');
    if (sa) { sa.hidden = !(v.c > v.p); if (v.c > v.p) sa.textContent = money(v.c); }
  }
  if (mapa) {
    document.addEventListener('change', function () { setTimeout(pintarPrecio, 60); }, true);
    var precioDawn = root.querySelector('[id^="price-"]');
    if (precioDawn && 'MutationObserver' in window) new MutationObserver(function () { setTimeout(pintarPrecio, 60); }).observe(precioDawn, { childList: true, subtree: true });
    setInterval(pintarPrecio, 1500); /* respaldo: el personalizador cambia la variante del combo sin evento */
    pintarPrecio();
  }

  /* La línea del cupón baja a la casilla del cupón (bm-coupon), donde se aplica. */
  if (cupon) {
    cupon.addEventListener('click', function () {
      var caja = document.querySelector('[data-bm-coupon]');
      if (!caja) return;
      bajarA(caja, 40);
      caja.classList.add('bm-ficha-cupon--marca');
      setTimeout(function () { caja.classList.remove('bm-ficha-cupon--marca'); }, 1800);
    });
  }

  /* ---------- 030: estrellas de arriba y «Ver más» bajan a todas las reseñas ---------- */
  function widgetResenas() {
    return document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-review-widget') ||
      document.querySelector('.jdgm-rev-widg');
  }
  function irAResenas(e) {
    var w = widgetResenas();
    if (!w) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    bajarA(w);
  }
  root.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.product__info-container .jdgm-prev-badge, .product__info-container .bmg--pdp') : null;
    if (t) irAResenas(e);
  }, true);
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target && e.target.closest ? e.target.closest('.product__info-container .jdgm-prev-badge, .product__info-container .bmg--pdp') : null;
    if (t) irAResenas(e);
  }, true);

  /* ---------- 030: 3 reseñas destacadas ---------- */
  var rd = root.querySelector('[data-bm-rd]');
  if (rd) {
    var lista = rd.querySelector('[data-bm-rd-list]');
    var titulo = (rd.getAttribute('data-titulo') || '').trim().toLowerCase();
    var mas = rd.querySelector('[data-bm-rd-mas]');
    if (mas) mas.addEventListener('click', irAResenas);

    var RE_EMOJI = /(?:[☀-➿]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDC00-\uDFFF]|[︎️‍⃣])/g;
    function limpio(s) {
      return String(s || '').replace(RE_EMOJI, '').replace(/\s+/g, ' ').replace(/\s+([.,;:!?])/g, '$1').trim();
    }
    function recorta(s, max) {
      if (s.length <= max) return s;
      var c = s.slice(0, max - 1);
      var i = c.lastIndexOf(' ');
      if (i > max * 0.6) c = c.slice(0, i);
      return c.replace(/[\s.,;:!?¡¿-]+$/, '') + '…';
    }
    function fotoDe(img) {
      if (!img) return '';
      var u = img.getAttribute('data-src') || img.getAttribute('src') || '';
      if (!/^https:\/\//.test(u) || !/judge\.?me/.test(u)) return '';
      u = u.replace(/&amp;/g, '&');
      if (/[?&]width=\d+/.test(u)) u = u.replace(/([?&])width=\d+/, '$1width=200');
      else u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      return u;
    }
    /* 9-oct-2026 (QA v116): Judge.me a veces trae como título de la reseña el NOMBRE del producto (con otro color
       o con «| Personalizado con Iniciales»). Leído como cita parece inventado: no se usa como texto. */
    var COLORES = /\b(black|brown|beige|pink|wine|blue|gray|grey|green|white|negro|caf[eé]|rosado|gris|azul|blanco|vinotinto)\b/g;
    var tituloSinColor = titulo.replace(COLORES, '').replace(/\s+/g, ' ').trim();
    function esNombreProducto(s) {
      var l = String(s || '').toLowerCase().trim();
      if (!l) return false;
      if (l === titulo || l.replace(COLORES, '').replace(/\s+/g, ' ').trim() === tituloSinColor) return true;
      return /\|/.test(l) || /personalizad[oa]s? con iniciales/.test(l);
    }
    function leer(scope) {
      var out = [];
      Array.prototype.slice.call(scope.querySelectorAll('.jdgm-rev')).forEach(function (r) {
        var rt = r.querySelector('.jdgm-rev__rating');
        var score = rt ? parseFloat(rt.getAttribute('data-score')) : 0;
        var autor = limpio((r.querySelector('.jdgm-rev__author') || {}).textContent);
        var tit = limpio((r.querySelector('.jdgm-rev__title') || {}).textContent);
        var cuerpo = limpio((r.querySelector('.jdgm-rev__body') || {}).textContent);
        if (cuerpo && esNombreProducto(cuerpo)) cuerpo = '';
        if (tit && esNombreProducto(tit)) tit = '';
        var texto = cuerpo || tit;
        if (cuerpo && tit && cuerpo.length < 40 && cuerpo.toLowerCase().indexOf(tit.toLowerCase()) === -1) texto = tit + '. ' + cuerpo;
        out.push({
          id: r.getAttribute('data-review-id') || (autor + texto),
          score: score,
          autor: autor,
          texto: texto,
          foto: fotoDe(r.querySelector('.jdgm-rev__pic-img, .jdgm-rev__pics img')),
          verif: r.getAttribute('data-verified-buyer') === 'true'
        });
      });
      return out;
    }
    function elegir(revs) {
      var vistos = {}, ok = [];
      revs.forEach(function (r, i) {
        if (vistos[r.id]) return;
        vistos[r.id] = 1;
        if (!(r.score >= 4) || !r.autor || !r.texto || r.texto.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/g, '').length < 8) return;
        var pri = (r.foto && r.score >= 5) ? 0 : (r.score >= 5 ? (r.texto.length >= 25 ? 1 : 2) : 3);
        /* Reseñas reales igual, pero las que hablan de demoras o reclamos van después de las demás. */
        if (/demor|retras|tard[oóe]|defect|reclam|devol|l[aá]stima|no me gust|decepci|imperfecc|hilos? (sueltos|por fuera)|descos/i.test(r.texto)) pri += 4; /* 9-oct: + imperfecciones, hilos sueltos, descosido */
        ok.push({ r: r, pri: pri, i: i });
      });
      ok.sort(function (a, b) { return a.pri - b.pri || a.i - b.i; });
      return ok.slice(0, 3).map(function (x) { return x.r; });
    }
    /* Visor de la reseña: <dialog> (Esc, foco atrapado y lector de pantalla los da el navegador).
       v119 · 15-oct-2026 (Wil): «quita el ícono de expandir, pero que al darle clic se expanda la reseña». Al tocar
       cualquier parte de la reseña (foto o texto) se abre completa: la foto en grande (si tiene), las estrellas, el
       texto entero y quién la escribió. Se cierra con la X, tocando el fondo o con Esc. Fondo claro. Se crea la
       primera vez que alguien toca una reseña: no pesa nada en la carga. */
    var dlg = null, dlgImg = null, dlgStars = null, dlgTxt = null, dlgAutor = null, dlgDesde = null;
    function cerrarVisor() { if (dlg && dlg.open) dlg.close(); }
    function visor(li) {
      var d = li && li.bmRd;
      if (!d) return;
      if (!window.HTMLDialogElement || !document.createElement('dialog').showModal) { if (d.grande) window.open(d.grande, '_blank', 'noopener'); return; }
      if (!dlg) {
        dlg = document.createElement('dialog');
        dlg.className = 'bm-rdv';
        dlg.innerHTML = '<button type="button" class="bm-rdv__x" aria-label="Cerrar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>' +
          '<figure class="bm-rdv__fig"><img class="bm-rdv__img" alt="" decoding="async">' +
          '<figcaption class="bm-rdv__rev"><span class="bm-rdv__stars" role="img"></span><p class="bm-rdv__txt"></p><span class="bm-rdv__autor"></span></figcaption></figure>';
        document.body.appendChild(dlg);
        dlgImg = dlg.querySelector('.bm-rdv__img');
        dlgStars = dlg.querySelector('.bm-rdv__stars');
        dlgTxt = dlg.querySelector('.bm-rdv__txt');
        dlgAutor = dlg.querySelector('.bm-rdv__autor');
        dlg.querySelector('.bm-rdv__x').addEventListener('click', cerrarVisor);
        /* tocar el fondo cierra; tocar la foto o el texto no */
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('bm-rdv__fig')) cerrarVisor(); });
        dlg.addEventListener('close', function () {
          document.documentElement.classList.remove('bm-rdv-on');
          dlgImg.removeAttribute('src');
          if (dlgDesde && dlgDesde.focus) { try { dlgDesde.focus({ preventScroll: true }); } catch (e) { dlgDesde.focus(); } }
        });
      }
      dlgDesde = li;
      dlg.setAttribute('aria-label', 'Reseña de ' + d.autor);
      if (d.grande) { dlgImg.hidden = false; dlgImg.alt = 'Foto de la reseña de ' + d.autor; dlgImg.src = d.grande; }
      else { dlgImg.hidden = true; dlgImg.removeAttribute('src'); }
      dlg.classList.toggle('bm-rdv--sinfoto', !d.grande);
      dlgStars.setAttribute('aria-label', d.n + ' de 5 estrellas');
      dlgStars.innerHTML = new Array(d.n + 1).join(ESTRELLA) + new Array(5 - d.n + 1).join(ESTRELLA_OFF);
      dlgTxt.textContent = '«' + d.texto + '»';
      dlgAutor.textContent = d.autor;
      if (d.verif) { var v = document.createElement('span'); v.className = 'bm-rd__verif'; v.textContent = 'Compra verificada'; dlgAutor.appendChild(v); }
      document.documentElement.classList.add('bm-rdv-on');
      dlg.showModal();
      dlgTxt.scrollTop = 0;
      var x = dlg.querySelector('.bm-rdv__x');
      try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); }
    }
    var ESTRELLA = '<svg viewBox="0 0 28 28" aria-hidden="true"><path d="M14.92 3.16A0.96 0.96 0 0 0 13.08 3.16L10.68 10.41L3.05 10.45A0.96 0.96 0 0 0 2.48 12.19L8.63 16.71L6.31 23.99A0.96 0.96 0 0 0 7.8 25.07L14 20.61L20.2 25.07A0.96 0.96 0 0 0 21.69 23.99L19.37 16.71L25.52 12.19A0.96 0.96 0 0 0 24.95 10.45L17.32 10.41Z"/></svg>'; /* v118 · 15-oct: estrella de Google Maps (su ícono ic_star_rate_14 redibujado en vector) */
    var ESTRELLA_OFF = ESTRELLA.replace('<svg ', '<svg class="off" ');
    var firma = '';
    function pintar(sel) {
      if (!lista) return;
      var f = sel.map(function (r) { return r.id; }).join('|');
      if (f === firma) return;
      firma = f;
      if (!sel.length) { rd.hidden = true; return; }
      lista.textContent = '';
      sel.forEach(function (r) {
        var li = document.createElement('li');
        li.className = 'bm-rd__item' + (r.foto ? ' bm-rd__item--foto' : '');
        var n = Math.max(0, Math.min(5, Math.round(r.score)));
        /* v119 · 15-oct-2026: toda la reseña es el botón (foto o texto) y abre la reseña completa en visor(); sin ícono. */
        li.bmRd = { autor: r.autor, texto: r.texto, n: n, verif: r.verif, grande: r.foto ? r.foto.replace(/([?&])width=\d+/, '$1width=1024') : '' };
        li.tabIndex = 0;
        li.setAttribute('role', 'button');
        li.setAttribute('aria-label', 'Ver la reseña completa de ' + r.autor);
        li.addEventListener('click', function () { visor(li); });
        li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); visor(li); } });
        if (r.foto) {
          /* v118 · Lupa 14-oct: la gente tocaba esta foto y no pasaba nada (18 de 21 toques muertos en el Tote Black). */
          var fb = document.createElement('span');
          fb.className = 'bm-rd__fotobtn';
          var im = document.createElement('img');
          im.className = 'bm-rd__foto';
          im.src = r.foto; im.alt = 'Foto de la reseña de ' + r.autor;
          im.width = 64; im.height = 64; im.loading = 'lazy'; im.decoding = 'async';
          im.addEventListener('error', function () { fb.remove(); li.classList.remove('bm-rd__item--foto'); li.bmRd.grande = ''; });
          fb.appendChild(im);
          li.appendChild(fb);
        }
        var box = document.createElement('div');
        box.className = 'bm-rd__txt';
        var st = document.createElement('span');
        st.className = 'bm-rd__stars';
        st.setAttribute('role', 'img');
        st.setAttribute('aria-label', n + ' de 5 estrellas');
        st.innerHTML = new Array(n + 1).join(ESTRELLA) + new Array(5 - n + 1).join(ESTRELLA_OFF); /* como Google: 5 estrellas, las que faltan en gris */
        var p = document.createElement('p');
        p.className = 'bm-rd__body';
        p.textContent = '«' + recorta(r.texto, 118) + '»';
        var a = document.createElement('span');
        a.className = 'bm-rd__autor';
        a.textContent = r.autor;
        if (r.verif) {
          var v = document.createElement('span');
          v.className = 'bm-rd__verif';
          v.textContent = 'Compra verificada';
          a.appendChild(v);
        }
        box.appendChild(st); box.appendChild(p); box.appendChild(a);
        li.appendChild(box);
        lista.appendChild(li);
      });
      rd.hidden = false;
    }
    /* 1) Lo que Judge.me ya trae en la página (sin esperar a nada). */
    var enPagina = [];
    function deLaPagina() {
      var w = document.querySelector('.jdgm-rev-widg');
      enPagina = w ? leer(w) : [];
      pintar(elegir(enPagina));
    }
    deLaPagina();
    /* 2) Las que tienen foto, del mismo servicio que usa el widget de Judge.me («Imágenes primero»). */
    function conFotos() {
      var pid = rd.getAttribute('data-pid'), shop = rd.getAttribute('data-shop');
      if (!pid || !shop || !window.fetch) return;
      var u = 'https://cdn.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&per_page=10&product_id=' + encodeURIComponent(pid) +
        '&sort_by=pictures_first';
      fetch(u, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.html) return;
          /* DOMParser: no ejecuta scripts ni carga imágenes al leer */
          var doc = new DOMParser().parseFromString('<div>' + j.html + '</div>', 'text/html');
          pintar(elegir(leer(doc.body).concat(enPagina)));
        })
        .catch(function () { /* se quedan las de la página */ });
    }
    /* Una sola petición pequeña (~25 KB): se pide ya, sin esperar a que cargue todo lo demás. */
    conFotos();
  }

  /* ---------- 018 B: WhatsApp flotante en el celular ---------- */
  /* Arriba va sobre la primera foto (no tapa título, precio ni iniciales); al bajar la galería
     vuelve a flotar abajo a la derecha, encima de la barra de compra (bm-ficha.css). */
  var wa = document.querySelector('.bm-wa');
  var lst = root.querySelector('.product__media-list');
  if (wa && lst) {
    var raf = 0;
    var bloqueContenedor = function () {
      for (var n = wa.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
        if (getComputedStyle(n).position !== 'static') return n;
      }
      return null;
    };
    var ubicar = function () {
      raf = 0;
      /* v118 (velocidad ficha): en el celular el botón espera oculto a que se ubique aquí (bm-ficha.css). Antes se veía
         abajo a la derecha y saltaba a la foto al cargar este script: 0,052 de CLS. */
      wa.classList.add('bm-wa--ubicada');
      if (!esCel()) { wa.classList.remove('bm-wa--foto'); return; }
      /* Esquina superior derecha de la 1.ª foto, debajo del sello HOT (foto de 262 px desde 16 px). */
      var r = lst.getBoundingClientRect();
      if (r.bottom > 120) {
        var cb = bloqueContenedor();
        var bx = cb ? cb.getBoundingClientRect() : { left: -window.pageXOffset, top: -window.pageYOffset };
        var izq = Math.min(r.left + 16 + 262 - 10 - 46, window.innerWidth - 16 - 46);
        wa.style.setProperty('--bmf-wa-top', Math.round(r.top - bx.top + 44) + 'px');
        wa.style.setProperty('--bmf-wa-left', Math.round(izq - bx.left) + 'px');
        wa.classList.add('bm-wa--foto');
      } else {
        wa.classList.remove('bm-wa--foto');
      }
    };
    var pedir = function () { if (!raf) raf = requestAnimationFrame(ubicar); };
    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    window.addEventListener('load', pedir);
    ubicar();
  }
})();

/* 9-oct-2026 (QA v116): imágenes rotas o vacías dentro de la descripción del producto (ej. Niva Pink: pink001.jpg
   ya no existe y dejaba el ícono roto y un hueco de ~400 px). Se quitan, y si el párrafo que las tenía queda vacío,
   también. No toca imágenes que cargan bien ni los párrafos vacíos que ya estaban en la descripción. */
(function () {
  'use strict';
  var cajas = document.querySelectorAll('.product__description');
  if (!cajas.length) return;
  /* v118 ronda 4: cada foto diferida lleva detr\u00e1s su <noscript> (bm-diferir); con JavaScript su contenido es texto
     (\u00ab<img \u2026>\u00bb) y hac\u00eda que el p\u00e1rrafo nunca contara como vac\u00edo. Ese texto no cuenta. */
  function vacio(el) {
    if (!el || el.querySelector('img, video, iframe, svg, picture')) return false;
    var t = '';
    (function leer(n) { Array.prototype.forEach.call(n.childNodes, function (c) {
      if (c.nodeType === 3) t += c.nodeValue; else if (c.nodeType === 1 && c.tagName !== 'NOSCRIPT') leer(c);
    }); })(el);
    return !t.replace(/[\s\u00a0]+/g, '');
  }
  function quitar(img) {
    if (!img || !img.parentNode) return;
    var p = img.closest('p, div, figure');
    img.remove();
    if (p && !p.classList.contains('product__description') && vacio(p)) p.remove();
  }
  Array.prototype.forEach.call(cajas, function (caja) {
    Array.prototype.forEach.call(caja.querySelectorAll('img'), function (img) {
      var src = img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-bm-src') || img.getAttribute('srcset') || img.getAttribute('data-bm-srcset') || '';
      if (!String(src).trim()) { quitar(img); return; }
      /* v118 (velocidad ficha): las fotos de la descripción llegan sin src hasta acercarse (bm-diferir). Una img sin src
         da complete = true y naturalWidth = 0: no es una foto rota. Con esas solo cuenta el error, cuando se suelten. */
      if (!img.getAttribute('src') && (img.hasAttribute('data-bm-src') || img.hasAttribute('data-bm-srcset'))) { img.addEventListener('error', function () { quitar(img); }, { once: true }); return; }
      /* un SVG sin medidas propias puede dar naturalWidth 0 aunque cargue bien: con esos solo cuenta el error */
      if (img.complete && img.naturalWidth === 0 && !/\.svg(\?|$)/i.test(src)) { quitar(img); return; }
      img.addEventListener('error', function () { quitar(img); }, { once: true });
    });
  });
})();
